import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import i18n from '../../i18n';
import { setOptional } from '../../actions/collection';
import { Icon } from '@homeexchange/design';

export const SignupCollectionAction = (props) => {
    const navigate = useNavigate();

    const handleClickBack = () => {
        if (props.onBackOverride && props.onBackOverride()) {
            return;
        }
        if (props.step === 1) {
            // Delete the last element of the pathname and delete the last '/'
            navigate(location.pathname.replace(/[^/]*$/, '').replace(/\/+$/, ''));
        } else {
            // Delete the last element of the pathname and repalace it by 'step...'
            navigate(location.pathname.replace(/[^/]*$/, `step${props.step - 1}`), {
                state: { fromStep: props.step }
            });
        }
    };

    const handleClickSkip = useCallback(() => {
        if (props.step === 4) {
            props.setOptional(false);
        }

        navigate(location.pathname.replace(/[^/]*$/, `step${props.step + 1}`));
    }, []);

    return (
        // put Next button on the right side when Back button is hidden
        <div className={classNames('btn-group-action', { 'right-side': props.step == 2 })}>
            <button onClick={handleClickBack} hidden={props.step == 2} className="btn-back-collection">
                <Icon name="ChevronLeft" />
                <span>{i18n.t('common:back')}</span>
            </button>
            <div className="btn-skip-next">
                {props.optional && !props.isValid && (
                    <button onClick={handleClickSkip} className="btn-skip-collection">
                        <span>{i18n.t('common:skip')}</span>
                    </button>
                )}
                <button
                    type="submit"
                    form={`form-step-${props.step}`}
                    disabled={!props.isValid}
                    className={classNames('btn btn-primary btn-ajax btn-next-collection', {
                        sending: props.isSending
                    })}
                >
                    <span>{props.nextLabel ?? i18n.t(`common:${props.step === 7 ? 'submit' : 'next'}`)}</span>
                    {!props.isSending && <i className="icon icon-ChevronRight is-medium" />}
                </button>
            </div>
        </div>
    );
};

SignupCollectionAction.propTypes = {
    step: PropTypes.number.isRequired,
    nextLabel: PropTypes.string,
    isValid: PropTypes.bool,
    isSending: PropTypes.bool,
    optional: PropTypes.bool,
    setOptional: PropTypes.func,
    onBackOverride: PropTypes.func
};

const mapDispatchToProps = (dispatch) => ({
    setOptional: bindActionCreators(setOptional, dispatch)
});

export default connect(null, mapDispatchToProps)(SignupCollectionAction);
